import { postViaWebWorker, removeHaveData } from './API'
import * as constants from '../../mixins/constants'

// Find administrative areas of all level of a given coordinate
export const geoFindAdministrative = (requestBody) => {
  const uri = constants.API.rest_api.place.find_admin_v3
  const baseURL = process.env.VUE_APP_REST_EP_API

  return postViaWebWorker(uri, requestBody, {
    baseURL,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 15000
  })
}

// Estimate fee for nationwide orders ( Method POST only)
export const estimatedFee = (params) => {
  const uri = constants.API.nationwide.estimated_fee
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 15000
  })
}

// Create nationwide orders
export const create = (params) => {
  const uri = constants.API.nationwide.create
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 15000 * 2.5
  })
}

// Cancel nationwide orders. Order can only be cancelled when its status is IDLE ( Method POST only)
export const cancel = (params) => {
  const { order_id } = params
  if (!order_id) return

  const uri = constants.API.nationwide.cancel

  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 15000 * 2.5
  })
}

export const cancelNationwideV3 = (params) => {
  const { order_id } = params

  if (!order_id) return

  const uri = constants.API.nationwide.cancelICT({ order_id })

  delete params.order_id

  return removeHaveData(
    uri,
    { ...params },
    {
      token_required_header: true,
      stringify_data: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}

// Geocode address to get latitude/longitude
export const geocodeAddress = (params) => {
  const uri = constants.API.route_planner.geocode_opstech_v3
  const baseURL = global.$_VUE_APP_REST_GW_MAP_API
  return postViaWebWorker(uri, params, {
    baseURL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
